import React from "react";
import LeftSidebar from "../../components/LeftSidebar";
import FlagEEUU from "../../assets/images/flag-eeuu.png";
import FlgSpain from "../../assets/images/flag-spain.png";
import { Chip } from "primereact/chip";
import { iconsTemplate, tab } from "../../core/utils";
import { Image } from "primereact/image";
import ReactPlayer from "react-player/lazy";
import { Divider } from "primereact/divider";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { downloadFiles } from "../../core/utils";

function ViewRequest({ visible, hide, items = {} }) {

    const safeItems = items || {};
    
    const UrgentBadge = () => (
        <div className="font-semibold" style={{ color: safeItems._URGENT ? "#4BAAF5" : "#6EBE71" }}>
            {safeItems._URGENT ? "YES" : "NO"}
        </div>
    );

    const LanguageChips = () => {
        if (!items._LANGUAGES) return null;
        return safeItems._LANGUAGES.split(",").map((language, i) => <Chip key={i} label={language} image={language === "ENGLISH" ? FlagEEUU : FlgSpain} className="ml-2 mr-2 w-max" />);
    };

    const ResourceItem = ({ resource, index }) => {
        const isVideo = resource.type === "Video";
        const isImage = !isVideo && !resource.resource.includes("https://letusclaimcons");
        const fileExt = resource.resource.split(".").pop().toLowerCase();

        return (
            <li className="py-2 surface-border" key={index}>
                <a className="p-ripple cursor-pointer flex align-items-center justify-content-between hover:surface-200 transition-colors transition-duration-150 border-round p-2" onClick={() => window.open(resource.resource, "_blank")}>
                    {isVideo ? (
                        <ReactPlayer url={resource.resource} width={100} height={60} style={{ borderRadius: "10px" }} />
                    ) : isImage ? (
                        <Image src={resource.resource} alt={resource._id} width={100} height={60} imageStyle={{ borderRadius: "10px" }} />
                    ) : (
                        <i className="pi pi-image" style={{ fontSize: "3em" }}></i>
                    )}
                    <div style={{ marginLeft: "20px" }}>
                        <span className="block text-900 mb-1">{resource._id}</span>
                    </div>
                    <i className="ml-auto pi pi-chevron-right text-600 text-sm"></i>
                </a>
            </li>
        );
    };

    const SocialMediaItem = ({ format, index }) => {
        const social = format.socialMedia;
        const icon = iconsTemplate(social);

        return (
            <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1 inline-flex align-items-center mb-2" key={index}>
                {format.socialFormat.map((dimension, x) => (
                    <div key={x} tooltip="Design Upload">
                        <Chip
                            className="mr-3"
                            template={
                                <span className="p-chip p-component w-max">
                                    {social === "TIKTOK" ? <FontAwesomeIcon icon={["fab", "tiktok"]} /> : <i className={`pi ${icon}`}></i>}
                                    {tab}
                                    <span className="p-chip-text">
                                        {social.toUpperCase()} - {dimension}
                                    </span>
                                </span>
                            }
                        />
                    </div>
                ))}
            </div>
        );
    };

    const TraditionalFormatItem = ({ format, index }) => {
        const social = format.socialMedia;
        const icon = iconsTemplate(social);
        const socialName = social.toUpperCase();

        return (
            <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1 inline-flex align-items-center mb-2" key={index}>
                <i className={`pi ${icon}`}></i>
                {format.socialFormat.map((dimension, x) => (
                    <div key={x}>
                        <Chip label={`${socialName} - ${dimension}`} className="ml-2 mr-2 w-max" />
                    </div>
                ))}
            </div>
        );
    };

    const FileItem = ({ file, index }) => {
        const fileExt = file.filename.split(".").pop().toLowerCase();
        const isVideo = fileExt === "mp4";
        const isImage = ["jpg", "png"].includes(fileExt);
        const isPDF = fileExt === "pdf";

        return (
            <li className="py-2 surface-border" key={index}>
                <a className="p-ripple cursor-pointer flex align-items-center justify-content-between hover:surface-200 transition-colors transition-duration-150 border-round p-2">
                    {isVideo ? (
                        <ReactPlayer url={file.pathUrl} width={100} height={60} style={{ borderRadius: "10px" }} />
                    ) : isImage ? (
                        <Image src={file.pathUrl} alt={file.filename} preview width={100} height={60} imageStyle={{ borderRadius: "10px" }} />
                    ) : isPDF ? (
                        <div className="cursor-pointer" onClick={() => downloadFiles(file.pathUrl, file.filename)}>
                            <i className="pi pi-file-pdf" style={{ fontSize: "3em" }}></i>
                        </div>
                    ) : (
                        <div className="cursor-pointer" onClick={() => downloadFiles(file.pathUrl, file.filename)}>
                            <i className="pi pi-file-word" style={{ fontSize: "3em" }}></i>
                        </div>
                    )}

                    <div style={{ marginLeft: "20px" }}>
                        <span className="block text-900 mb-1">{file._id}</span>
                    </div>

                    <div className="cursor-pointer" onClick={() => downloadFiles(file.pathUrl, file.filename)}>
                        <i className="ml-auto mr-5 pi pi-download text-600 text-xl"></i>
                    </div>
                </a>
            </li>
        );
    };

    const renderSocialResources = () =>
        safeItems._RESOURCES?.length ? (
            <ul className="list-none p-0 m-0 w-full">
                {items._RESOURCES.map((resource, i) => (
                    <ResourceItem key={i} resource={resource} index={i} />
                ))}
            </ul>
        ) : null;

    const renderSocialMedia = () => (safeItems._FORMATS?.length ? safeItems._FORMATS.map((format, i) => <SocialMediaItem key={i} format={format} index={i} />) : null);

    const renderTraditionalFormat = () => (safeItems._FORMATS?.length ? safeItems._FORMATS.map((format, i) => <TraditionalFormatItem key={i} format={format} index={i} />) : null);

    const renderRequestFiles = () =>
        safeItems._FILES?.length ? (
            <ul className="list-none p-0 m-0 w-full">
                {safeItems._FILES.map((file, i) => (
                    <FileItem key={i} file={file} index={i} />
                ))}
            </ul>
        ) : null;

    const renderVideoInfo = () =>
        safeItems._ISVIDEO === "YES" && (
            <>
                <li className="flex align-items-center py-3 px-2 border-top-1 border-300 flex-wrap">
                    <div className="text-500 w-6 md:w-2 font-medium">This is a video request</div>
                    <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{safeItems._ISVIDEO}</div>
                </li>

                <li className="flex align-items-center py-3 px-2 border-top-1 border-300 flex-wrap">
                    <div className="text-500 w-6 md:w-2 font-medium">Video Time</div>
                    <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{safeItems._TIME}</div>
                </li>

                <li className="flex align-items-center py-3 px-2 border-top-1 border-300 flex-wrap">
                    <div className="text-500 w-6 md:w-2 font-medium">Video Subtitle</div>
                    <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{safeItems._SUBTITLE}</div>
                </li>
            </>
        );

    return (
        <LeftSidebar onVisible={visible} onHide={hide} onWidth={600}>
            <h2 className="text-color">Request Information</h2>

            <div className="surface-0">
                <ul className="list-none p-0 m-0">
                    <InfoItem label="Urgent" content={<UrgentBadge />} />
                    <InfoItem label="Type" content={ safeItems._TYPE  } />

                    {safeItems._CAMPAIGN && <InfoItem label="Campaign" content={safeItems._CAMPAIGN} />}

                    <InfoItem label="Languages" content={<LanguageChips />} />
                    <InfoItem label="Account" content={safeItems._ACCOUNT} />

                    <InfoItem label="Date request created" content={<span className="text-pink-600 font-medium">{safeItems._DCREATE}</span>} />

                    <InfoItem label="Handle date" content={safeItems._DHANDLE} />
                    <InfoItem label="Publication date" content={safeItems._DPUBLIC} />

                    <InfoItem label="Text" content={<div style={{ whiteSpace: "break-spaces" }}>{safeItems._CONCEPT}</div>} />

                    <InfoItem label="Caption" content={<div style={{ whiteSpace: "break-spaces" }}>{safeItems._CAPTION}</div>} />

                    <InfoItem label="Description" content={<div style={{ whiteSpace: "break-spaces" }}>{safeItems._DESCRIPTION}</div>} />

                    {safeItems._TYPEFORMAT === "traditional" ? <InfoItem label="Traditional Format" content={renderTraditionalFormat()} /> : <InfoItem label="Social Media" content={renderSocialMedia()} />}

                    {renderVideoInfo()}

                    <li className="flex align-items-center py-3 px-2 border-top-1 border-300 flex-wrap">
                        <h5>Online Resources</h5>
                        {renderSocialResources()}
                    </li>

                    <li className="flex align-items-center py-3 px-2 border-top-1 border-300 flex-wrap">
                        <h5>Files</h5>
                        {renderRequestFiles()}
                    </li>
                </ul>
            </div>
        </LeftSidebar>
    );
}

const InfoItem = ({ label, content }) => (
    <li className="flex align-items-center py-3 px-2 border-top-1 border-300 flex-wrap">
        <div className="text-500 w-6 md:w-2 font-medium">{label}</div>
        <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{content}</div>
    </li>
);

export default React.memo(ViewRequest);
